import {
  DashboardTableDialogBody,
  DashboardTableDialogContent,
  DashboardTableDialogFooter,
  DashboardTableDialogHeader,
} from '@shigo-ui/dashboard-ui';
import { Button, Dialog } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import type { Integration } from '../../model';
import { IntegrationPlacementsDialogTable } from './IntegrationPlacementsDialogTable';

export function IntegrationPlacementsDialog({
  integration,
  onOpenChange,
}: {
  integration: Integration;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DashboardTableDialogContent>
        <DashboardTableDialogHeader
          title={dashboardT('integrations.placementsFor', { name: integration.name })}
        />
        <DashboardTableDialogBody>
          <IntegrationPlacementsDialogTable
            integrationId={integration.id}
            tableLabel={dashboardT('integrations.placementsFor', { name: integration.name })}
          />
        </DashboardTableDialogBody>
        <DashboardTableDialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            {dashboardT('placements.close')}
          </Button>
        </DashboardTableDialogFooter>
      </DashboardTableDialogContent>
    </Dialog>
  );
}
